import React from 'react';
import ReactSelect, { MultiValue } from 'react-select';
import { ClinicMasterProductSelectorOption, ClinicMasterProductSelectorProps } from './interface';
import useDebouncedSearchTerm from '../../hooks/useDebouncedSearchTerm';
import { isString } from './utils';
import useClinicMasterProductOptions from './useClinicMasterProductOptions';

function ClinicMasterProductSelector(props: ClinicMasterProductSelectorProps) {
  const { value: clinicMasterProductsIds, onChange, clinicId } = props;

  const { setValue, immediateValue } = useDebouncedSearchTerm();

  const { options, selectedOptions } = useClinicMasterProductOptions({
    clinicId,
    selectedClinicMasterProductsIds: clinicMasterProductsIds
  });

  const handleSelectChange = (options: MultiValue<ClinicMasterProductSelectorOption>) => {
    const values = options.map(option => option.value).filter(isString);

    onChange(values);
  };

  return (
    <ReactSelect
      placeholder="Enter product name"
      options={options}
      isMulti
      value={selectedOptions}
      inputValue={immediateValue}
      onInputChange={setValue}
      onChange={handleSelectChange}
    />
  );
}

export default ClinicMasterProductSelector;
